import { FC, PropsWithChildren, ReactNode, useMemo, useState } from 'react'

export interface PopoverProps {
  show: boolean
  content: ReactNode
  offsetX?: number
  position?: 'top' | 'bottom'
}

type Position = {
  x: number
  y: number
}

const Popover: FC<PropsWithChildren<PopoverProps>> = ({ children, content, show, offsetX, position = 'top' }) => {
  const contentWrapperCls = useMemo(() => {
    if (position === 'top') {
      return '-translate-y-full'
    }
    return 'mt-1'
  }, [position])

  const top = useMemo(() => {
    return position === 'top' ? -8 : 'calc(100% + 8px)'
  }, [position])

  return (
    <div className="pd-popover relative w-full h-full">
      {children}
      <div
        className={[
          'absolute -translate-x-1/2 transition-all duration-800 ease-in-out scale-0 opacity-0',
          contentWrapperCls,
          show ? '!opacity-100 !scale-100' : '',
        ].join(' ')}
        style={{ left: `calc(50% + ${offsetX ?? 0}px)`, top: top }}
      >
        {content}
      </div>
    </div>
  )
}

export default Popover
